<template>
	<div>
		<div class="page-bg">
			<div class="logo">
				<img src="../assets/logo.png" alt="" />
			</div>
			<div class="wechat-moments-page">


				<div class="title-bar fcc">
					<img src="../assets/rysy.png" alt="" />
				</div>

				<div class="fcc upload-group">
					<!-- https://vant.pro/vant/v2/#/zh-CN/uploader -->
					<div class="item">
						<van-uploader  :before-read="beforeRead"   :max-count="1" :after-read="afterRead" v-model="fileList" preview-size="44vw">
							<img src="../assets/upload.png" alt="" class="icon">
						</van-uploader>
					</div>
					<div class="item">
						<van-uploader  :before-read="beforeRead"   :max-count="1" :after-read="afterRead2" v-model="fileList2" preview-size="44vw">
							<img src="../assets/upload.png" alt="" class="icon">
						</van-uploader>
					</div>
				</div>
				<div class="p">
					记录下今天最喜欢的欢乐瞬间<br />
					上传至您的社交圈附上文案<br />
					集满20个赞并截图上传至H5即可获得积分
				</div>
			</div>

			<i-nav></i-nav>
		</div>




	</div>
</template>

<script>

import { getWechatMomentsTask, saveWechatMomentsTask } from "@/api/api";
import axios from 'axios';

export default {

	data() {
		return {
			fileList: [],
			fileList2: [],
			uid: null,
      maxSize: 1024 * 1024 * 3, // 假设限制为 2MB
		};
	},
	async mounted() {
		this.uid = window.localStorage.getItem('cscec2026UserId')
		if (!this.uid) {
			this.$router.push({ path: '/' })
			return
		}
		this.getWechatMomentsTask()


	},
	methods: {
    beforeRead(file) {
      // 在这里检查文件大小
      if (file.size > this.maxSize) {
        this.$toast.fail('文件大小不能超过3MB!');
        return false; // 阻止文件读取
      }
      return true; // 允许文件读取
    },
    getWechatMomentsTask() {
			getWechatMomentsTask({ userId: this.uid }).then(res => {
				this.taskList = res
        console.info("this.taskList=====>",this.taskList)
        if(this.taskList.length===1){
          this.fileList.push({ url: this.taskList[0].pic });
        }
        if(this.taskList.length>1){
          this.fileList.push({ url: this.taskList[0].pic });
          this.fileList2.push({ url: this.taskList[1].pic });
        }

        console.info("this.fileList=====>",this.fileList)
        console.info("this.fileList2=====>",this.fileList2)
			})
		},
		async afterRead(file) {
			// 创建FormData
			const formData = new FormData();
			formData.append('file', file.file);
			let response = await this.upload(formData)
			console.log("response", response)
			if (response.errno == 0) {
				this.submit(response.link,'分享1')
				setTimeout(() => {
					file.status = 'success';
					file.message = '上传成功';
				}, 1000);

			} else {
				setTimeout(() => {
					file.status = 'failed';
					file.message = '上传失败';
				}, 1000);
			}

		},
    async afterRead2(file) {
			// 创建FormData
			const formData = new FormData();
			formData.append('file', file.file);
			let response = await this.upload(formData)
			console.log("response", response)
			if (response.errno == 0) {
				this.submit(response.link,'分享2')
				setTimeout(() => {
					file.status = 'success';
					file.message = '上传成功';
				}, 1000);

			} else {
				setTimeout(() => {
					file.status = 'failed';
					file.message = '上传失败';
				}, 1000);
			}

		},
		async upload(formData) {
			// 返回一个Promise
			return new Promise((resolve, reject) => {
				axios.post('https://cscec.warnny.com/api/upload', formData, {
					headers: {
						'Content-Type': 'multipart/form-data',
					},
				}).then(response => {
					console.log("101response", response)
					resolve(response.data);
				}).catch(error => {
					reject(error);
				});
			});
		},
		//提交任务
		submit(url,taskName) {
			saveWechatMomentsTask({
				userId: this.uid,
				pic: url,
				taskName: taskName,
			}).then(res => {
				if (res) {
					this.$toast("上传成功")
				}
			})
		}
	}
};
</script>
<style scoped lang="less"></style>
